import { useState } from "react";
import { motion } from "framer-motion";
import { useStore } from "@/store/useStore";
import { getAudio } from "@/audio";

export default function Landing() {
  const setEntered = useStore((s) => s.setEntered);
  const setPlaying = useStore((s) => s.setPlaying);
  const [leaving, setLeaving] = useState(false);

  const enter = () => {
    // Start the commentary from the click so autoplay policy doesn't block it.
    try {
      const audio = getAudio();
      audio.currentTime = 0;
      audio.play().then(() => setPlaying(true)).catch(() => {});
    } catch (e) {
      /* no-op */
    }
    setLeaving(true);
    setTimeout(() => setEntered(true), 620);
  };

  return (
    <motion.div
      data-testid="landing-screen-container"
      className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center"
      style={{
        background:
          "radial-gradient(ellipse at 50% 35%, #ffffff 0%, #f1f3f6 45%, #e4e7ec 100%)",
      }}
      animate={leaving ? { opacity: 0, scale: 1.04, filter: "blur(6px)" } : { opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
    >
      {/* faint guilloché rings */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.06]">
        <div className="h-[560px] w-[560px] rounded-full border border-[#0f172a]" />
        <div className="absolute h-[700px] w-[700px] rounded-full border border-[#0f172a]" />
        <div className="absolute h-[420px] w-[420px] rounded-full border border-[#0f172a]" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
        className="relative z-10 flex flex-col items-center"
      >
        <div className="eyebrow mb-6 text-[#8a7324]">TIME Inventions 2025 · Special Report</div>

        <div className="seal-pulse rounded-full">
          <img
            src="/tab-seal.png"
            alt="The Academic Boardroom seal"
            data-testid="tab-seal-logo"
            className="h-40 w-40 rounded-full object-cover shadow-[0_18px_60px_rgba(15,23,42,0.28)] sm:h-52 sm:w-52"
          />
        </div>

        <h1 className="font-display mt-9 text-3xl font-bold leading-tight tracking-tight text-[#0a0d14] sm:text-5xl lg:text-6xl">
          THE ACADEMIC BOARDROOM
        </h1>
        <div className="mt-2 flex items-center gap-3">
          <span className="h-px w-8 bg-[#c7a233]" />
          <span className="font-display text-base italic text-[#6b5a1f] sm:text-xl">
            Spatial Report of Innovation
          </span>
          <span className="h-px w-8 bg-[#c7a233]" />
        </div>

        <p className="mt-6 max-w-md text-sm leading-relaxed text-[#5a6578] sm:text-base">
          A Mock immersive XR preview prepared exclusively for the TIME Best Inventions 2025.
          <span className="mt-1 block text-xs uppercase tracking-[0.2em] text-[#94a0b4]">
            Immersive Hardware Showroom &amp; Innovation Engine
          </span>
        </p>

        <button
          data-testid="landing-enter-showroom-button"
          onClick={enter}
          className="gold-btn mt-12 rounded-full px-10 py-4 text-sm uppercase tracking-[0.18em] sm:text-base"
        >
          Enter the Showroom
        </button>

        <div className="mono mt-10 flex items-center gap-2 text-[0.72rem] uppercase tracking-[0.2em] text-[#9aa4b6]">
          <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-[#c7a233]" />
          WebXR Spatial Engine · GLB 3D Pipeline
        </div>
      </motion.div>
    </motion.div>
  );
}
